// Rangées des cartes de réglages de la modale : l'intitulé à gauche, le champ
// en face. Les 250px d'intitulé du formulaire ne tiennent pas dans une colonne
// de demi-largeur — antd renvoie alors le champ sous son intitulé, et chaque
// rangée s'aligne autrement de sa voisine.
export const MODAL_LABEL_WIDTH = '190px';

export const modalFieldLayout = {
  labelCol: { flex: MODAL_LABEL_WIDTH },
  wrapperCol: { flex: 1 },
};

// Largeur commune des champs, pour qu'ils s'alignent d'une rangée à l'autre.
export const MODAL_FIELD_WIDTH = 150;

// En-tête d'un groupe de réglages : les groupes se répondent, à la même hauteur.
export const FieldGroupTitle = ({ children }) => (
  <div style={{ fontWeight: 'bold', marginBottom: '1rem' }}>{children}</div>
);
